/**
 * region for libraries*/
import React, { Component } from 'react';
import ReactApexChart from "react-apexcharts";

/**
 * region for component*/
import { WorkingLayer } from '../../../../components/common/WorkingLayer';

/**
 * region for helpers*/
import ajax from '../../../../helpers/ajax';
import typing from '../../../../helpers/typing';

/**
 * region for constants*/
import Constants from '../../../../constants/Constants'

export class KeywordsModifiedChart extends Component {
    static displayName = KeywordsModifiedChart.name;

    constructor(props) {
        super(props);

        this.state = {
            modificationsTotal: 0,
            mode: Constants.MODE_LOADING,
            filters: { ...this.props.filters },
            organizationTypes: { ...this.props.organizationTypes },         
            options: {
                chart: {
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: false
                    }
                },
                responsive: [{
                    breakpoint: 1500,
                    options: {
                        chart: {
                            width: 300,
                            height: 200
                        },
                    }
                }],
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'straight'
                },
                title: {
                    text: 'Keywords',
                    align: 'left',
                    style: {
                        fontSize: "20px",
                        fontWeight: 100,
                        color: '#666'
                    }
                },
                subtitle: {
                    text: 'Modifications',
                    align: 'left',
                    style: {
                        fontWeight: 100
                    }
                },
                legend: {
                    fontWeight: 100,
                },
                grid: {
                    show: false,
                },
                xaxis: {
                    type: 'datetime',
                    labels: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    categories: [],
                }
            },
            series: [{
                name: '',
                data: []
            }],
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!typing.areEqual(this.state.filters, nextProps.filters)) {
            this.setState({
                mode: Constants.MODE_LOADING,
                filters: { ...nextProps.filters }
            }, function () { this.load(); });
        }
    }

    load() {

        const self = this;

        let requestData = {
            ...this.state.filters,
        };

        let titleText;

        if(Object.keys(this.state.organizationTypes).length > 0  && requestData.idContentOrganizationType !== undefined)
        {
            titleText = Object.values(this.state.organizationTypes).find(x => x.IDCONTENTORGANIZATIONTYPE === requestData.idContentOrganizationType);
        }

        titleText = (titleText === undefined)? "All Types" : titleText.NAME;
        
        ajax.get(Constants.ROUTE_API_CONTENTORGANIZATION_CHART_KEYWORDS_MODIFIED,
            {
                requestData: requestData,
                success: function (response) {
                    let optionsCopy = Object.assign({}, self.state.options);
                    let seriesUpdated = response.data.map(serie => serie.SUMMATION);
                    let modificationsAddedTotal =  seriesUpdated.reduce((result,element) => result + element);

                    let labelsUpdated = response.data.map(label => label.LOGDATE);

                    optionsCopy.xaxis.categories = labelsUpdated;
                    optionsCopy.title.text = titleText;

                    self.setState({
                        modificationsTotal: modificationsAddedTotal,
                        mode: Constants.MODE_LOADED,
                        options: optionsCopy,
                        series: [{
                            name: '',
                            data: seriesUpdated
                        }]
                       
                    });
                }
            });
    }

    componentDidMount() {
        const self = this;
        self.load();
    }


    render() {

        if (this.state.mode === Constants.MODE_LOADING) {
            return <WorkingLayer />
        }

        return (
            <div className="chart-container-activity">
                <div className="total-values-chart-activity">
                    Modifications Total {this.state.modificationsTotal}
                </div>
                <div className="col-4 col-md-6">
                <div id="chart">
                    <ReactApexChart options={this.state.options} series={this.state.series} type="area" height="200" width="400" />
                </div>
                </div>
            </div>
        )
    }
}



    

   
